import { EmployeeServicePath } from "utils/constants";
import { buildFilterQueryString, toDateOnly } from "utils/helpers";

// The period is a path segment, so a missing date must fail here instead of reaching the backend.
const substitutionsPeriod = (dateFrom, dateTo) => {
  const from = toDateOnly(dateFrom);
  const to = toDateOnly(dateTo);
  if (!from || !to) throw new Error("The substitutions endpoint requires dateFrom and dateTo");
  return `${from}/${to}`;
};

export const employeeRequests = {
  getEmployeeById: id => `${EmployeeServicePath}employees/${id}`,
  activateEmployee: id => `${EmployeeServicePath}employees/${id}/activate`,
  deactivateEmployee: id => `${EmployeeServicePath}employees/${id}/deactivate`,
  getEmployeePositionTypes: id => `${EmployeeServicePath}employees/${id}/position-types`,
  getEmployeeContracts: employeeId =>
    `${EmployeeServicePath}employees/contracts${buildFilterQueryString({ employeeId })}`,

  getPositionApprovalSubstitutes: positionId => `${EmployeeServicePath}positions/${positionId}/approval-substitutes`,
  updatePositionApprovalSubstitutes: positionId => `${EmployeeServicePath}positions/${positionId}/approval-substitutes`,

  getLeaveById: id => `${EmployeeServicePath}leaves/${id}`,
  updateLeave: id => `${EmployeeServicePath}leaves/${id}`,
  createLeave: () => `${EmployeeServicePath}leaves`,
  correctLeave: id => `${EmployeeServicePath}leaves/${id}/corrections`,

  getSickLeaveById: id => `${EmployeeServicePath}leaves/sick-leaves/${id}`,
  updateSickLeave: id => `${EmployeeServicePath}leaves/sick-leaves/${id}`,
  createSickLeave: () => `${EmployeeServicePath}leaves/sick-leaves`,

  getBusinessTripById: id => `${EmployeeServicePath}leaves/business-trips/${id}`,
  updateBusinessTrip: id => `${EmployeeServicePath}leaves/business-trips/${id}`,
  createBusinessTrip: () => `${EmployeeServicePath}leaves/business-trips`,
  getBusinessTripTemplates: ({ key, type, category } = {}) =>
    `${EmployeeServicePath}leaves/business-trips/templates${buildFilterQueryString({ key, type, category })}`,
  uploadBusinessTripReportFile: id => `${EmployeeServicePath}leaves/business-trips/${id}/final-report`,

  getScheduleSubstitutionRequestById: id => `${EmployeeServicePath}staff-requests/schedule-substitutions/${id}`,
  getClassMakeUpRequestById: id => `${EmployeeServicePath}class-make-up-requests/${id}`,
  getStaffRequestStatusReasons: ({ type, status, ids, excludeIds } = {}) =>
    `${EmployeeServicePath}status-reasons${buildFilterQueryString({ type, status, ids, excludeIds })}`,
  approveStaffRequest: id => `${EmployeeServicePath}staff-requests/${id}/approve`,
  rejectStaffRequest: id => `${EmployeeServicePath}staff-requests/${id}/reject`,
  bulkApproveStaffRequests: () => `${EmployeeServicePath}staff-requests/bulk-approve`,
  bulkRejectStaffRequests: () => `${EmployeeServicePath}staff-requests/bulk-reject`,
  cancelStaffRequest: id => `${EmployeeServicePath}staff-requests/${id}/cancel`,
  deleteLeaveDocument: (leaveId, documentId) => `${EmployeeServicePath}leaves/${leaveId}/documents/${documentId}`,
  uploadLeaveDocument: leaveId => `${EmployeeServicePath}leaves/${leaveId}/documents`,
  uploadLeaveDocumentAttachments: leaveId => `${EmployeeServicePath}leaves/${leaveId}/documents/attachments`,
  getDocumentTypes: reasonId => `${EmployeeServicePath}leaves/document-types?ReasonId=${reasonId}`,
  getRemainingVacationDays: employeeId =>
    `${EmployeeServicePath}leaves/remainings${buildFilterQueryString({ employeeId })}`,

  getPendingStaffRequestsCount: () => `${EmployeeServicePath}staff-requests/count-pending`,

  //Selects
  getEmployeesSelect: () => `${EmployeeServicePath}selects/employees`,
  getEmployeesWithDegreeSelect: () => `${EmployeeServicePath}selects/employees-with-degree`,
  getProfessorsSelect: () => `${EmployeeServicePath}selects/professors`,
  getProfessorsByIdsSelect: ids => `${EmployeeServicePath}selects/professors${buildFilterQueryString({ ids })}`,
  getDepartmentLeadsSelect: departmentId => `${EmployeeServicePath}selects/departments/${departmentId}/leads`,
  getPositionsSelect: () => `${EmployeeServicePath}selects/positions`,
  getPositionTypesSelect: () => `${EmployeeServicePath}selects/positions/types`,
  getScientificDegreesSelect: () => `${EmployeeServicePath}selects/scientific-degrees`,
  getSubstitutionsSelect: (dateFrom, dateTo) =>
    `${EmployeeServicePath}leaves/substitutions/${substitutionsPeriod(dateFrom, dateTo)}`,
  getSubstitutionsByIdsSelect: (dateFrom, dateTo, ids) =>
    `${EmployeeServicePath}leaves/substitutions/${substitutionsPeriod(dateFrom, dateTo)}${buildFilterQueryString({ ids })}`,
  getBusinessTripsSelect: () => `${EmployeeServicePath}types/business-trips`,
  getLeaveTransportsSelect: () => `${EmployeeServicePath}types/transports`,
  getSickLeaveTypesSelect: () => `${EmployeeServicePath}types/sick-leaves`,
  getDomesticTripCategoriesSelect: () => `${EmployeeServicePath}types/domestic-trip-categories`,
  getLeaveReasonsSelect: () => `${EmployeeServicePath}leaves/reasons`,
};
